module.exports = __webpack_public_path__ + "img/adorno-2.7486bdc6.png";